import { defineStore } from 'pinia';
import { ref } from 'vue';
import { cartEndpoint } from '../services/nopAPI';

export const useCartStore = defineStore('cart', () => {
  const cartItems = ref([]);

  async function addToCart(productId, quantity) {
    try {
      const cart = await cartEndpoint.addToCart(productId, quantity);
      if (cart.success === false) {
      showErrorNotification(cart.message || 'Failed to add to cart.');
      return;
    }
      showCartNotification(cart);
    } catch (error) {
      console.log(error);
    }
  }
  
  function showErrorNotification(message) {
    window.displayBarNotification(message, 'error', 5000);
  }
  
  function showCartNotification(cartItems) {
    try{
      // return cart;
      window.displayBarNotification('The product has been added to your <a href="/cart">shopping cart</a>', 'success', 3500);
      // flyout-cart
      document.getElementById('flyout-cart').innerHTML = cartItems.updateflyoutcartsectionhtml;
    
      document.querySelectorAll('span#myitemcount')[0].innerHTML = cartItems.updatesidecartsectionhtml;
      document.querySelectorAll('span.cart-qty')[0].innerHTML = cartItems.updatesidecartsectionhtml;
    
      document.getElementsByClassName('ajax-loading-block-window')[0].style.display = 'none';
      try {
        let currentitem = document.querySelectorAll('.mini-shopping-cart .item').length;
        console.log(currentitem, 'currentitem');
        if (currentitem != 0) {
    
          document.getElementById('fixed-cart-box').style.display = 'block';
         
          console.log('success');
        } 
        else {
          console.log('success else');
          document.getElementById('fixed-cart-box').style.display = 'none';
        }
      } 
      catch (err) {
        document.getElementById('fixed-cart-box').style.display = 'none';
      }
    }
    catch(err){
      document.getElementById('fixed-cart-box').style.display = 'none';
    }
  }

  return { cartItems, addToCart };
});
